// @flow

import purchaseInvoiceSourceItemSelectorFieldConfiguration from './components/configuration/purchaseInvoiceSourceItemSelectorFieldConfiguration';
import purchaseInvoiceItemSelectorFieldConfiguration from './components/configuration/purchaseInvoiceItemSelectorFieldConfiguration';

import TradeTimelineItem from '../../trix-web-plugin-wms-trade/web/components/timeline/TradeTimelineItem';

export const components = {
    'configuration:trix-web-plugin-fms-purchaseinvoice.managePurchaseInvoicePage.container.purchaseInvoiceLinesTable.action.onAddItemFromSource.editor._.purchaseInvoiceSourceItem': purchaseInvoiceSourceItemSelectorFieldConfiguration,
    'timelineItem:trix-web-plugin-fms-purchaseinvoice.managePurchaseInvoicePage.container.trade': TradeTimelineItem,

    'configuration:trix-web-plugin-fms-purchaseinvoice.manageCreditNotePage.container.creditNoteLinesTable.action.onAddItem.editor._.purchaseInvoiceItem': purchaseInvoiceItemSelectorFieldConfiguration,
    'configuration:trix-web-plugin-fms-purchaseinvoice.manageCreditNotePage.container.creditNoteLinesTable.action.onAddItemFromPurchaseReturn.editor._.purchaseInvoiceSourceItem': purchaseInvoiceSourceItemSelectorFieldConfiguration,
    'timelineItem:trix-web-plugin-fms-purchaseinvoice.manageCreditNotePage.container.trade': TradeTimelineItem,
}
